import React from 'react';
import styled from 'styled-components';
import { UiBox } from '@open-stack/ui';
import clsx from 'clsx';
import { XButton, XButtonInput } from '@orderx/lab/ui';

const Wrapper = styled.div`
    &.hasPlaceholder {
        height: calc(var(--bottom-nav-height) + 2 * var(--ui-spacing));
    }

    .button-container {
        position: fixed;
        z-index: calc(var(--z-index-toolbar) + 1);
        background: var(--bottom-nav-background);
        box-shadow: var(--bottom-nav-box-shadow);
        height: var(--bottom-nav-height);
        border-radius: var(--bottom-nav-border-radius);
        bottom: calc(2 * var(--ui-spacing));
        width: calc(100% - 2 * 12px);
        max-width: var(--drawer-max-width);
        left: 50%;
        transform: translateX(-50%);

        > * {
            border-radius: 40px;
        }

        .XButton {
            height: var(--bottom-nav-height);
            text-transform: uppercase;
            letter-spacing: 1px;

            &[disabled] {
                opacity: 0.5 !important;
            }
        }
    }
`;

interface Props extends XButtonInput {
    hasPlaceholder?: boolean;
}

export function XButtonBottom({ hasPlaceholder, ...rest }: Props) {
    return (
        <Wrapper className={clsx({ hasPlaceholder })}>
            <div className="button-container">
                <UiBox backgroundColor="surface" className="animate__animated animate__fadeInUp">
                    <XButton {...rest} fullWidth />
                </UiBox>
            </div>
        </Wrapper>
    );
}
